export const POPULAR_BANKS = [
  { id: "sbi", name: "State Bank of India", color: "#1a4f9c" },
  { id: "hdfc", name: "HDFC Bank", color: "#004c8f" },
  { id: "indian", name: "Indian Bank", color: "#00843d" },
  { id: "rbl", name: "RBL Bank", color: "#1f2a63" },
  { id: "icici", name: "ICICI Bank", color: "#ae282e" },
  { id: "pnb", name: "Punjab National Bank", color: "#7a0f16" },
  { id: "kotak", name: "Kotak Bank", color: "#ed1c24" },
  { id: "hsbc", name: "HSBC Bank", color: "#db0011" },
];

export const ALL_BANKS = [
  ...POPULAR_BANKS,
  { id: "axis", name: "Axis Bank", color: "#971237" },
  { id: "yes", name: "Yes Bank", color: "#004990" },
  { id: "bob", name: "Bank of Baroda", color: "#f57c20" },
  { id: "canara", name: "Canara Bank", color: "#0084d0" },
];

export const BANK_ACCOUNTS = [
  {
    id: "acc1",
    bankId: "hdfc",
    type: "Savings account",
    masked: "*********7797",
  },
];
